import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { AnonSessionService } from '../services/anon-session.service';

export function httpTokenInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const localStorageService = inject(LocalStorageService);
  const anon = inject(AnonSessionService);

  const token = localStorageService.getAccessToken();
  const lang = localStorageService.getLang() || 'ru';
  // console.log('lang:', lang);

  let modifiedRequest = request;

  // Add token if available
  if (token) {
    modifiedRequest = request.clone({
      setHeaders: {
        'x-access-token': token,
      },
    });
  }

  // Пока нет токена — представляемся анонимной сессией (§1.1).
  // С токеном заголовок не нужен: сессия уже стала аккаунтом.
  if (!token) {
    const anonId = anon.id();
    if (anonId) {
      modifiedRequest = modifiedRequest.clone({ setHeaders: { 'X-Anon-Id': anonId } });
    }
  }

  // Add language if available
  if (lang) {
    modifiedRequest = modifiedRequest.clone({
      setHeaders: {
        'language': lang,
      },
    });
  }

  // console.log('Request headers:', modifiedRequest.headers);
  return next(modifiedRequest);
}
